import { t } from '@/ui/i18n/i18n';
import { defineComponent, h } from 'vue';
import { Modal, modalProps, ModalProps } from '@/ui/components/Modal';
import { button } from '@/ui/components';
import { ButtonProps } from '@/ui/components/Button';

interface ConfirmationModalProps extends ModalProps {
  confirmText?: string;
  declineText?: string;
  width?: string;
  declineButtonProps?: ButtonProps;
  confirmationButtonProps?: ButtonProps;
  hideClose?: boolean;
  hideTitle?: boolean;
}

export const ConfirmationModal = defineComponent<ConfirmationModalProps>({
  name: 'ConfirmationModal',
  props: [...modalProps, 'confirmText', 'declineText', 'declineButtonProps', 'confirmationButtonProps', 'hideClose', 'hideTitle'],
  setup(props, ctx) {
    return function render() {
      return h(
        Modal,
        {
          props: {
            ...props,
            hideClose: props.hideClose ?? true,
            width: props.width ?? '500px',
          },
          on: {
            close: () => {
              ctx.emit('close');
            },
          },
          scopedSlots: {
            title: props.hideTitle ? undefined : () => ctx.slots.title?.(),
          },
        },
        [
          ctx.slots.default?.(),
          h('template', { slot: 'actions' }, [
            button(props.declineText ?? t('common.cancel'), () => ctx.emit('declined'), undefined, { btnClass: 'mr-2', type: 'is-text', ...props.declineButtonProps }),
            button(props.confirmText ?? t('common.confirm'), () => ctx.emit('accepted'), undefined, props.confirmationButtonProps),
          ]),
        ],
      );
    };
  },
});
